module.exports = __webpack_public_path__ + "img/img92.7e6e40fe.svg";